import script from "./HomeCustomerAge.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCustomerAge.vue?vue&type=script&setup=true&lang=js"

import "./HomeCustomerAge.vue?vue&type=style&index=0&id=e0970efa&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0970efa"]])

export default __exports__